import {
	type DatePanelMode,
	DateView,
} from "web_myplann/Shared/Types/DateView";

export const resolveDatePanelMode = (views: DateView[]): DatePanelMode =>
	views.includes(DateView.Day) ? DateView.Day : DateView.Month;
